// extracted by mini-css-extract-plugin
export default {"List":"List_List__oVr9L","Item":"List_Item__O9b2P","Title":"List_Title__LWtZY","Button":"List_Button__tGH1V index_Button__OaIuy"};